<template>
  <div>
    <div class="wrap reflection-notes-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>성찰노트</h3>
      </div>
      <div class="body-wrap">
        <!-- <div class="time">
                    <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘">
                    <p>{{course.startDate}}({{course.day}}) {{course.start_time}}~{{course.end_time}} ({{course.time}}분)</p>
                </div> -->
        <incCourse :idx="idx"></incCourse>

        <div class="notes">
          <div>
            <p>이번 코칭 후 새롭게 알게 된점</p>
            <textarea placeholder="코칭 후 새롭게 배운 점이나 깨닫게 된 점을 작성해주세요." v-model="input.courseReflectionContent1"></textarea>
          </div>

          <div>
            <p>코칭 과제 및 실행 계획</p>
            <textarea placeholder="이번 코칭의 과제와 그에 대한 실행 계획을 잘성해 주세요." v-model="input.courseReflectionContent2"></textarea>
          </div>

          <div>
            <p>이후 나의 변화된 모습</p>
            <textarea placeholder="코칭 이후 본인의 개선점과 앞으로 기대하는 부분을 작성해 주세요" v-model="input.courseReflectionContent3"></textarea>
          </div>
        </div>
      </div>
      <div class="coaching-btn">
        <button @click="save()">저장하기</button>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import incCourse from "@/components/inc/inc_course.vue";

export default {
  name: "reflection_notes_modify",

  props: {
    idx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    course: {},
    input: {
      sessionIdx: 0,
      courseIdx: 0,
      courseReflectionContent1: "",
      courseReflectionContent2: "",
      courseReflectionContent3: "",
    },
  }),
  components: { incBack, incCourse },
  mounted() {
    this.getReflicationDetail();
  },
  methods: {
    getReflicationDetail() {
      let params = {
        sessionIdx: this.idx,
        courseIdx: this.$store.state.courseInfo.courseIdx,
      };
      this.axios
        .get("/front/coarching/complete/reflication/detail", { params })
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            this.input.courseReflectionContent1 = res.data.contentinfo.reflectionContent1;
            this.input.courseReflectionContent2 = res.data.contentinfo.reflectionContent2;
            this.input.courseReflectionContent3 = res.data.contentinfo.reflectionContent3;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    save() {
      if (this.input.courseReflectionContent1 == "") {
        alert("코칭 후 새롭게 알게된점을 작성해주세요.");
        return false;
      }
      if (this.input.courseReflectionContent2 == "") {
        alert("코칭 과제 및 실행계획을 작성해주세요.");
        return false;
      }
      if (this.input.courseReflectionContent3 == "") {
        alert("코칭 이후 나의 변환된 모습을 작성해주세요.");
        return false;
      }
      this.input.sessionIdx = this.idx;
      this.input.courseIdx = this.$store.state.courseInfo.courseIdx;
      let form = new FormData();
      for (const [key, value] of Object.entries(this.input)) {
        form.append(key, value);
      }
      this.axios
        .post("/front/coarching/complete/reflication/edit", form)
        .then((res) => {
          if (res.data.success) {
            alert("성찰노트 수정이 완료되었습니다.");
            this.$router.replace({ name: "coaching_finish", params: { sessionIdx: this.idx } });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
